<template>
  <v-card outlined>
    <ValidationObserver ref="form">
      <v-container>
        <v-toolbar flat dense>
          <div>{{$t("deliveryMethod.totalPrice")}}</div>
        </v-toolbar>
        <ValidationProvider rules="min_value:0" name="min_total_price" v-slot="{ errors }">
          <v-text-field
            :label="$t('deliveryMethod.min')"
            v-model="totalPrices.min"
            type="number"
            :suffix="currency"
            clearable
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
        <ValidationProvider
          :rules="totalPrices.min > 0 ? 'min_value:'+totalPrices.min : 'min_value:0'"
          name="max_total_price"
          v-slot="{ errors }"
        >
          <v-text-field
            :label="$t('deliveryMethod.max')"
            v-model="totalPrices.max"
            type="number"
            :suffix="currency"
            clearable
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
      </v-container>
    </ValidationObserver>
  </v-card>
</template>

<script>
  import { ValidationProvider, extend, ValidationObserver } from "vee-validate"
  import { min_value } from 'vee-validate/dist/rules'

  extend('min_value', {
    ...min_value,
    params: ['min']
  })

  export default {
    name: "totalPriceEligibility",
    components: {
      "ValidationProvider": ValidationProvider,
      "ValidationObserver": ValidationObserver,
    },
    props: {
      totalPrices: {
        type: Object,
        default: null,
      },
      loading: {
        type: Boolean,
        default: false
      },
      currency: {
        type: String,
        default: "EUR"
      }
    },
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.width <= 600
      },
    },
    methods: {
      validateForm() {
        return this.$refs.form.validate()
      },
    }
  }
</script>

